import React from 'react';
import { cn } from '@/lib/utils';
import { ModernPlayIcon, PlayIconTheme } from '@/components/ui/icons/ModernPlayIcon';
import { ThemedIcon } from './ThemedIcon';

interface PlayButtonProps {
  isPlaying: boolean;
  onClick: () => void;
  iconType: PlayIconTheme;
  small?: boolean;
  color?: string;
}

export const PlayButton: React.FC<PlayButtonProps> = ({
  isPlaying,
  onClick,
  iconType,
  small = false,
  color = '#FFFFFF',
}) => {
  // Tema Safari: o play também ganha o círculo translúcido com blur.
  const isSafari = iconType === 'safari';
  return (
    <button
      onClick={onClick}
      className={cn(
        'flex items-center justify-center rounded-full transition-colors',
        small ? 'h-8 w-8' : 'h-10 w-10',
        isSafari ? 'bg-white/10 backdrop-blur-md ring-1 ring-white/25 shadow-sm hover:bg-white/20' : 'hover:bg-white/15'
      )}
      style={{ color }}
    >
      {isPlaying ? (
        <ThemedIcon name="pause" theme={iconType} className="h-5 w-5" />
      ) : (
        <ModernPlayIcon iconType={iconType} className="h-full w-full" />
      )}
    </button>
  );
};
